import React from 'react';
import { c as classnames } from './index-2586sEvh.js';
import { T as TextHighlighter } from './TextHighlighter-ZyVmLG-I.js';

const InputAutocompleteOption = ({ option, searchText, isFocused, onSelect }) => {
    const text = option.label;
    const onClick = () => {
        onSelect(option);
    };
    const onKeyPress = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.key !== 'Enter')
            return;
        onSelect(option);
    };
    return (React.createElement("button", { type: "button", className: classnames('autocomplete-list-item', {
            focused: isFocused,
        }), title: text, onClick: onClick, onKeyUp: onKeyPress },
        React.createElement(TextHighlighter, { text: text, searchText: searchText })));
};

export { InputAutocompleteOption as I };
//# sourceMappingURL=InputAutocompleteOption-ZBLmHamR.js.map
